import { MasterType, W2MasterData } from '@/common/model/master/w2Master'

export const W2MasterApiPath = {
  LIST_W2_MASTER: '/api/sites/{site_id}/w2/{master_type}', // GET List W2 Master
  GET_W2_MASTER_RECORD: '/api/sites/{site_id}/w2/{master_type}/{record_id}', // GET Get W2 Master Record
  CREATE_W2_MASTER: '/api/sites/{site_id}/w2/{master_type}', // POST Create W2 Master
  UPDATE_W2_MASTER: '/api/sites/{site_id}/w2/{master_type}/{record_id}', // PUT Update W2 Master
  BULK_CREATE_W2_MASTER: '/api/sites/{site_id}/w2/{master_type}/bulk', // POST Bulk Create W2 Master
  DELETE_ALL_W2_MASTER: '/api/sites/{site_id}/w2/{master_type}/all', // DELETE Delete All W2 Master
  DELETE_W2_MASTER_RECORD: '/api/sites/{site_id}/w2/{master_type}/{record_id}' // DELETE Delete W2 Master Record
}

export type W2MasterApiPath = (typeof W2MasterApiPath)[keyof typeof W2MasterApiPath]

export interface ListW2MasterVars {
  site_id: number
  master_type: MasterType
  page?: number
  per_page?: number
  search?: string | null
  sort_by?: string
  sort_order?: string
}

export interface GetW2MasterRecordVars {
  site_id: number
  master_type: MasterType
  record_id: number
}

export interface GetW2MasterRecordResponse extends W2MasterData {}

export interface CreateW2MasterVars {
  site_id: number
  master_type: MasterType
  data: W2MasterData
}

export interface UpdateW2MasterVars {
  site_id: number
  master_type: MasterType
  record_id: number
  data: W2MasterData
}

export interface BulkCreateW2MasterVars {
  site_id: number
  master_type: MasterType
  items: W2MasterData[]
}

export interface DeleteAllW2MasterVars {
  site_id: number
  master_type: MasterType
}

export interface DeleteW2MasterRecordVars {
  site_id: number
  master_type: MasterType
  record_id: number
}

export interface ListW2MasterResponse {
  total: number
  page: number
  per_page: number
  items: W2MasterData[]
}

export interface CreateW2MasterResponse {
  action: string
  record: W2MasterData
}

export type UpdateW2MasterResponse = W2MasterData

export interface BulkCreateW2MasterResponse {
  created: number
  updated: number
  errors: string[]
}

export interface DeleteAllW2MasterResponse {
  deleted: number
}

export interface DeleteW2MasterRecordResponse {
  deleted: boolean
}
